
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/my-games",
      function () {
        return require("private-next-pages/dashboard/my-games.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/my-games"])
      });
    }
  